import {
  BooleanInput,
  CheckboxGroupInput,
  Create,
  CreateContextProvider,
  DateTimeInput,
  Form,
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  TextInput,
  Toolbar,
  TopToolbar,
  useCreateController,
  useNotify,
  useRecordContext,
  useRedirect,
  useTranslate,
} from 'react-admin';
import {
  Box,
  Card,
  Divider,
  Stack,
  Typography,
  Button as MUIButton,
  Tooltip,
  IconButton,
} from '@mui/material';
import { Resources } from '../../resource';
import { useEffect, useRef, useState } from 'react';
import useAdminConfig from './useAdminConfig';
import { useFormContext, useWatch } from 'react-hook-form';

interface FormProps {
  isCreate: boolean;
}
const AdminConfigForm = (props: FormProps) => {
  const { isCreate } = props;
  const t = useTranslate();
  const { findConfig } = useAdminConfig();
  const [addressMessage, setAddressMessage] = useState('');
  const dataType = useWatch({ name: 'dataType' });
  const { setValue } = useFormContext();

  const handleCheckCode = async (e: React.FocusEvent<HTMLInputElement>) => {
    const code = e.target.value.trim();
    if (!code) return;

    try {
      const result = await findConfig(code);
      setAddressMessage(t('module.adminConfig.validate.conflict'));
    } catch (error: any) {
      setAddressMessage('');
    }
  };

  return (
    <>
      <Stack spacing={3} gap={2}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          spacing={2}
          mb={1}
        >
          <Typography variant="body2" sx={{ flexBasis: '25%', flexShrink: 0 }}>
            {t('module.adminConfig.code')}
          </Typography>
          <Box sx={{ flexGrow: 1 }}>
            <TextInput
              source="code"
              label=""
              placeholder={t('module.adminConfig.code')}
              validate={[
                required(),
                () => (addressMessage !== '' ? addressMessage : undefined),
              ]}
              onBlur={handleCheckCode}
              disabled={!isCreate}
              fullWidth
              helperText={<span style={{ color: 'red' }}>{addressMessage}</span>}
              onKeyDown={(e) => {
                if (e.key === ' ') e.preventDefault();
              }}
            />
          </Box>
        </Stack>
        <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
          <Typography
            variant="body2"
            sx={{ flexBasis: '25%', flexShrink: 0 }}
          >
            {t("module.adminConfig.description")}
          </Typography>
          <Box
            sx={{ flexGrow: 1 }}
          >
            <TextInput
              source="description"
              label=""
              placeholder={t("module.adminConfig.description")}
              fullWidth
              multiline
              helperText={<span style={{ color: 'red' }}></span>}
              rows={3}
            />
          </Box>

        </Stack>
        <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
          <Typography
            variant="body2"
            sx={{ flexBasis: '25%', flexShrink: 0 }}
          >
            {t("module.adminConfig.enable")}
          </Typography>
          <Box
            sx={{ flexGrow: 1 }}
          >
            <BooleanInput label='' source="enable" helperText={<span style={{ color: 'red' }}>{""}</span>} />
          </Box>

        </Stack>
        <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
          <Typography
            variant="body2"
            sx={{ flexBasis: '25%', flexShrink: 0 }}
          >
            {t("module.adminConfig.dataType")}
          </Typography>
          <Box
            sx={{ flexGrow: 1 }}
          >
            <SelectInput
              source="dataType"
              label=''
              defaultValue={'string'}
              choices={[
                { id: 'string', name: 'String' },
                { id: 'number', name: 'Number' },
                { id: 'object', name: 'Object' },
              ]}
              onChange={(e) => {
                setValue('value', '');
                return e.target.value;
              }}
              fullWidth
              validate={[required()]}
              helperText={<span style={{ color: 'red' }}></span>}
            />
          </Box>

        </Stack>

        <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
          <Typography
            variant="body2"
            sx={{ flexBasis: '25%', flexShrink: 0 }}
          >
            {t("module.adminConfig.value")}
          </Typography>
          <Box
            sx={{ flexGrow: 1 }}
          >
            {dataType === 'string' && (
              <TextInput
                source="value"
                label=""
                fullWidth
                validate={[required()]}
                placeholder={t("module.adminConfig.validate.string")}
                helperText={<span style={{ color: 'red' }}></span>}
              />
            )}

            {dataType === 'number' && (
              <NumberInput
                source="value"
                label=""
                fullWidth
                validate={[
                  required(),
                  (value) => (isNaN(value) ? t("module.adminConfig.validate.invalidNumber") : undefined),
                ]}
                placeholder={t("module.adminConfig.validate.number")}
                helperText={<span style={{ color: 'red' }}></span>}
              />
            )}

            {dataType === 'object' && (
              <TextInput
                source="value"
                label=""
                fullWidth
                multiline
                rows={4}
                placeholder={t("module.adminConfig.validate.object")}
                helperText={<span style={{ color: 'red' }}></span>}
                validate={[
                  required(),
                  (value) => {
                    try {
                      const parsed = JSON.parse(value);
                      return typeof parsed === 'object' ? undefined : t("module.adminConfig.validate.invalidObject");
                    } catch {
                      return t("module.adminConfig.validate.invalidObject");
                    }
                  },
                ]}
              />
            )}
            {/* <TextInput
              source="value"
              label=""
              validate={[
                required()
              ]}
              placeholder={t("module.adminConfig.value")}
              fullWidth
              multiline
              helperText={<span style={{ color: 'red' }}></span>}
              rows={4}
            /> */}
          </Box>

        </Stack>



      </Stack>
    </>
  );
};

export default AdminConfigForm;
